export const STEPS = {
  INDIVIDUAL_PHOTOS: 'INDIVIDUAL_PHOTOS',
  TEAM_PHOTOS: 'TEAM_PHOTOS',
};
